import { Plugin } from '~/models/Plugin'
import Vue3Lottie from 'vue3-lottie'

export const install: Plugin['fn'] = (app) => {
    app.use(Vue3Lottie, { name: 'LottieAnimation' })
}
